// Main columns configuration
import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";

export const financialDocumentationCols = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({ viewModal, updateModal, deleteRecord });

  return {
    Asset: [
      {
        title: "Asset Type",
        dataIndex: "module",
        key: "assetType",
        render: (text) => text || "N/A",
      },
      {
        title: "Name of Asset",
        dataIndex: "Name of Asset",
        key: "assetsName",
        render: (text) => text || "N/A",
      },
      {
        title: "Account Type",
        dataIndex: "Account Type/Titled",
        key: "accountType",
        render: (text) => text || "N/A",
      },
      {
        title: "Monetary Value",
        dataIndex: "Monetary Value",
        key: "monetaryValue",
        render: (text) => text || "N/A",
      },
      actionColumn,
    ],
    Loans: [
      {
        title: "Name of Credit ",
        dataIndex: "Nickname of Credit",
        key: "Nickname of Credit",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Owner",
        dataIndex: "Owner",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Bank",
        dataIndex: "Bank",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Credit Limit",
        dataIndex: "Credit Limit",
        render: (record) =>
          record
            ? !isNaN(record)
              ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              : "N/A"
            : "N/A",
      },
      {
        title: "Monthly Payment",
        dataIndex: "Monthly Payment",
        render: (record) =>
          record
            ? !isNaN(record)
              ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              : "N/A"
            : "N/A",
      },
      {
        title: "Interest Rate(or APR%)",
        dataIndex: "Interest Rate (or APR%)",
        render: (record) => (record ? `${record + "%"} ` : "N/A"),
      },
      {
        title: "Credit Balance",
        dataIndex: "Credit Balance",
        render: (record) =>
          record
            ? !isNaN(record)
              ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              : "N/A"
            : "N/A",
      },
      actionColumn,
    ],
    "Safe Deposit Box Information": [
      {
        title: "Bank",
        dataIndex: "Bank",
        key: "bank",
      },
      {
        title: "Box Number",
        dataIndex: "Box Number",
        key: "boxnumber",
      },
      {
        title: "Data Backup Systems",
        dataIndex: "Data Backup Systems",
        key: "databackupsystems",
      },
      actionColumn,
    ],
    Income: [
      {
        title: "Type of Income",
        dataIndex: "module",
        key: "module",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Income Name",
        dataIndex: "Income Name",
        key: "Income Name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Gross Amount",
        dataIndex: "Gross Monthly Wages",
        key: "Gross Monthly Wages",
        render: (record) =>
          record
            ? !isNaN(record)
              ? `$${parseFloat(record)
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              : "N/A"
            : "N/A",
      },
      {
        title: "Active/Passive",
        dataIndex: "Passive or Active",
        key: "Passive or Active",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Frequency",
        dataIndex: "Frequency of Pay Periods",
        key: "Frequency of Pay Periods",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Tax Record": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "Document Name",
      },
      {
        title: "Year",
        dataIndex: "Year",
        key: "Year",
      },
      actionColumn,
    ],
  };
};
